"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ClickableTextWeb = ({ children, style, onClick, type = 'Black', active = false }) => {
    const typeClass = type === 'Black' ? 'black' : (type === 'Blue' ? 'blue' : 'smooth');
    return ((0, jsx_runtime_1.jsx)("span", { onClick: onClick, className: `clickable-text ${typeClass} ${active ? 'active' : ''}`, style: style || {}, children: children }));
};
exports.default = ClickableTextWeb;
